import {FC} from 'react';
import {Stack} from '@mui/system';
import {Button, styled} from '@mui/material';
import {ContractDataImportsTable} from './contract-data-imports-table';
import {AddImportsModal} from './add-imports-modal';
import {contractDataImportsAddModalOpen} from '../../stores/contract-data-imports-add-modal.store';
import {useCompanyTariffGuard} from '../../../company-tariff';

export const ContractDataImports: FC = () => {
  const {checkTariff, tariffLoading} = useCompanyTariffGuard();

  const handleImport = () => {
    if (!checkTariff(true)) return;

    contractDataImportsAddModalOpen();
  };

  return (
    <Stack direction="column" spacing={4}>
      <StyledButton variant="contained" onClick={handleImport} disabled={tariffLoading}>
        Импорт
      </StyledButton>
      <ContractDataImportsTable />
      <AddImportsModal />
    </Stack>
  );
};

const StyledButton = styled(Button)({
  alignSelf: 'flex-end',
  textTransform: 'none',
});
